module.exports = __webpack_public_path__ + "img/mech-duct-velocity.5c520f9f.jpg";